import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class ConfigService<T> {
  private _config$: ReplaySubject<T> = new ReplaySubject(1);

  get config$() {
    return this._config$.asObservable();
  }

  setConfig(config: T) {
    this._config$.next(config);
  }
}
